import axiosInstance from "../lib/axios.instance";
import type {
  ChatHistoryRequest,
  ChatHistoryResponse,
  ChatQueryRequest,
  ChatQueryResponse,
  ISubmitFeedbackRequest,
  ISubmitFeedbackResponse,
  ICreateRequestRequest,
  ICreateRequestResponse,
} from "../types/discuss.types";

const BASE_URL = "/ai/chat";
const FEEDBACK_ENDPOINT = "/documents/feedback/";

export const getChatHistory = async (payload: ChatHistoryRequest): Promise<ChatHistoryResponse> => {
  const response = await axiosInstance.post<ChatHistoryResponse>(`${BASE_URL}/get_chat`, payload);
  return response.data;
};

export const sendChatMessage = async (payload: ChatQueryRequest): Promise<ChatQueryResponse> => {
  const response = await axiosInstance.post<ChatQueryResponse>(`${BASE_URL}/query`, payload);
  return response.data;
};

export const getDiscussChatHistoryForDocument = async (
  documentId: string
): Promise<ChatHistoryResponse> => {
  const payload: ChatHistoryRequest = {
    current_document_id: documentId,
    document_id: [documentId],
  };
  return getChatHistory(payload);
};

export const submitFeedback = async (
  payload: ISubmitFeedbackRequest
): Promise<ISubmitFeedbackResponse> => {
  const response = await axiosInstance.post<ISubmitFeedbackResponse>(FEEDBACK_ENDPOINT, payload);
  return response.data;
};

export const createRequest = async (
  payload: ICreateRequestRequest
): Promise<ICreateRequestResponse> => {
  const response = await axiosInstance.post<ICreateRequestResponse>(`${BASE_URL}/request`, payload);
  return response.data;
};
